import gsap from 'gsap'

function imgZoom() {
    const images = document.querySelectorAll('.block--wide-image img')

    images.forEach((img) => {
        if (window.innerWidth < 768) {
            let isZoomed = false
            let startX = 0
            let startY = 0
            let translateX = 0
            let translateY = 0

            const scale = 3.5

            const container = document.createElement('div')
            container.style.overflow = 'hidden'
            container.style.position = 'relative'
            img.parentNode.insertBefore(container, img)
            container.appendChild(img)

            const zoomIcon = document.createElement('div')
            zoomIcon.innerHTML = `
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M21 21L16.65 16.65" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M11 8V14" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M8 11H14" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>`
            zoomIcon.style.cssText = `
                position: absolute;
                right: 10px;
                bottom: 10px;
                background: rgba(0, 0, 0, 0.5);
                padding: 8px;
                border-radius: 50%;
                pointer-events: none;
                transition: opacity 0.3s;
            `
            container.appendChild(zoomIcon)

            gsap.set(img, {
                cursor: 'zoom-in',
            })

            img.addEventListener('click', () => {
                if (!isZoomed) {
                    gsap.to(img, {
                        scale,
                        duration: 0.3,
                        ease: 'power2.out',
                        cursor: 'grab',
                    })
                    gsap.to(zoomIcon, {
                        opacity: 0,
                        duration: 0.3,
                    })
                    isZoomed = true
                } else {
                    gsap.to(img, {
                        scale: 1,
                        x: 0,
                        y: 0,
                        duration: 0.3,
                        ease: 'power2.out',
                        cursor: 'zoom-in',
                    })
                    gsap.to(zoomIcon, {
                        opacity: 1,
                        duration: 0.3,
                    })
                    translateX = 0
                    translateY = 0
                    isZoomed = false
                }
            })

            img.addEventListener('touchstart', (e) => {
                if (!isZoomed) return
                startX = e.touches[0].clientX - translateX
                startY = e.touches[0].clientY - translateY
                gsap.set(img, { cursor: 'grabbing' })
            })

            img.addEventListener('touchmove', (e) => {
                if (!isZoomed) return
                e.preventDefault()

                const x = e.touches[0].clientX - startX
                const y = e.touches[0].clientY - startY

                const maxX = (img.width * (scale - 1)) / 2
                const maxY = (img.height * (scale - 1)) / 2

                translateX = Math.min(Math.max(x, -maxX), maxX)
                translateY = Math.min(Math.max(y, -maxY), maxY)

                gsap.to(img, {
                    x: translateX,
                    y: translateY,
                    scale,
                    duration: 0.1,
                    ease: 'power1.out',
                })
            })

            img.addEventListener('touchend', () => {
                if (!isZoomed) return
                gsap.set(img, { cursor: 'grab' })
            })
        }
    })
}

export { imgZoom }
